<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link to="/Home">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    </div>
    <router-view/>
    <el-backtop target="" :bottom="70">
      <div 
        style="{
          height: 100%;
          width: 100%;
          background-color: #f2f5f6;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          line-height: 40px;
          color: #3277BC;
        }"
      >
        <van-icon name="back-top" />
      </div>
    </el-backtop>
  </div>
</template>

<style lang="scss">


</style>


<script>
import { Locale } from 'vant';

export default {
  data() {
    return {};
  },
  mounted() {
    let randomNum = Math.random(); // 这里的范围根据需求进行调整
    // this.UpdataLang();
      if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        // this.$router.push({
        //         path: '/mHome', 
        //         query: { v: randomNum }
        //     });
        // this.$router.replace('/mHome')
      } else {
        // this.$router.push({
        //         path: '/PHome', 
        //         query: { v: randomNum }
        //     });
            // this.$router.replace('/PHome')
      }
    

  },
  methods:{
    UpdataLang() {
      if(localStorage.language){
        if(localStorage.language == 'ENG'){
          this.$i18n.locale = 'ENG';
          // Locale.use('ENG', enUS)
          // this.$i18n.setLocaleMessage('ENG')
        }else{
          this.$i18n.locale = 'CHN';
          // Locale.use('CHN', zhCN)
          // this.$i18n.setLocaleMessage('CHN')
        }
      }else{
        this.$i18n.locale = 'CHN';
        // Locale.use('CHN', zhCN) 
      }
      
    },
  
    
  }
}
</script>

